(() => {
	angular
		.module('main')
		.directive('integrateWithXeroModal', integrateWithXeroModal);

	integrateWithXeroModal.$inject = ['$http', '$location', 'messageService'];

	function integrateWithXeroModal($http, $location, messageService) {
		return {
			restrict: 'E',
			scope: {
				accounts: '<'
			},
			template: `
                   <div id="integrateWithXeroModal" class="modal modal-center fade" data-backdrop="static" data-keyboard="false">
                        <div class="modal-dialog">
                            <div class="modal-content">
                                <form class="form-horizontal form-group" role="form" ng-submit="saveXeroSettings()">
                                    <div class="modal-header">
                                        <btn-close ng-click=changePathAfterIntegration()></btn-close>
                                        <h3 class="modal-title">Xero integration settings</h3>
                                    </div>
                                    <div class="modal-body">
                    
                                        <p>Creating invoices in Studio Ninja will automatically copy them to your Xero account.</p>
                                        <hr class="mb-30 mt-30">
                                        <h3 class="mb-30">Default revenue account</h3>
                    
                                        <div class="field-info">
                                            <p>Choose revenue account (we will copy your invoices to this account):</p>
                    
                                            <div class="flex-row">
                    
                                                <div class="select-style flex-grow-1">
                                                   <select ng-model="chosenRevenueAccount" required
                                                            ng-options="account as account.value for account in accounts.revenueAccounts | orderBy track by account.key">
                                                    </select>
                                                </div>                
                    
                                            </div>
                                        </div>
                                        <hr class="mb-30 mt-30">
                                        <h3 class="mb-30">Default payment account</h3>
                                        <div class="field-info">
                                            <div class="flex-row mb-10">
                                                <div class="checkbox-squared">
                                                    <input type="checkbox" id="checkbox-squared-copy-payments"
                                                           ng-model="enablePaymentsCopying"/>
                                                    <label for="checkbox-squared-copy-payments"></label>
                                                </div>
                                                <label for="checkbox-squared-copy-payments">Sync payments with Xero</label>
                                            </div>
                                            <p ng-show="enablePaymentsCopying" class="mt-30">Choose payment account (all Studio Ninja payments will be applied to this account):</p>
                                             <div ng-show="enablePaymentsCopying" class="flex-row flex-wrap">
                                                <div class="select-style flex-grow-1">
                                                    <select ng-model="chosenPaymentAccount" required
                                                            ng-options="account as account.value for account in accounts.paymentAccounts | orderBy track by account.key">
                                                    </select>
                                                </div>
                                                <div class="flex-row flex-wrap-xs warning-message m-0 mt-30"> 
                                                   <img src="https://app.studioninja.co/build/release-pipeline-51/resources/dist/assets/images/icons/warning-sign-icon.png" class="warning-message__img" alt="warning-sign">
                                                    <div class="warning-message__text mr-10">
                                                        <p>If you’re receiving payments via Stripe or PayPal and your Xero account is connected to your bank feed, syncing payments with Xero may cause the same payment to be recorded twice. To avoid recording the same payment twice, disable “sync payments with Xero”.</p>
                                                    </div>
                                                </div> 
                                             </div>
                                        </div>
                    
                                    </div>
                    
                                    <div class="modal-footer modal-foot pb-30">
                                        <button class="btn btn-success btn-submit pull-left" 
                                                type="submit"
                                                ng-disabled="button_disabled"
                                                spinning-wheel is-spinning-wheel-active="button_disabled"
                                        >Save settings
                                        </button>
                                        <button type="button" class="btn btn-lg btn-default ml-10" 
                                                data-dismiss="modal"
                                                ng-click="changePathAfterIntegration()"
                                                ng-disabled="button_disabled"
                                        >Cancel
                                        </button>
                                    </div>
                    
                    
                                </form>
                            </div>
                        </div>
                    </div>
`,
			replace: true,
			transclude: true,
			link(scope) {
				const integrateModal = '#integrateWithXeroModal';

				const setXeroAccounts = () => {
					const {
						currentPaymentAccountId,
						currentRevenueAccountId,
						paymentAccounts,
						revenueAccounts
					} = scope.accounts;

					scope.chosenPaymentAccount = currentPaymentAccountId
						? paymentAccounts.find(
								account => account.key === currentPaymentAccountId
						  )
						: paymentAccounts[0];

					scope.chosenRevenueAccount = currentRevenueAccountId
						? revenueAccounts.find(
								account => account.key === currentRevenueAccountId
						  )
						: revenueAccounts[0];

					scope.enablePaymentsCopying = !!currentPaymentAccountId;
				};

				scope.$watch(
					'accounts',
					(newValue, oldValue) => {
						if (newValue && newValue !== oldValue) {
							setXeroAccounts();
						}
					},
					true
				);

				const successSetAccount = () => {
					$(integrateModal).modal('hide');
					messageService.showToaster('s_0', 'xero');
				};

				const gatherData2Save = () => ({
					revenueAccount: scope.chosenRevenueAccount
						? scope.chosenRevenueAccount.key
						: null,
					paymentAccount: scope.chosenPaymentAccount
						? scope.chosenPaymentAccount.key
						: null,
					enablePaymentsCopying: scope.enablePaymentsCopying
				});

				scope.changePathAfterIntegration = () => {
					const path = $location.path();
					const pathWithoutXero = path.replace('/xero', '');
					$location.url(pathWithoutXero);
					scope.button_disabled = false;
				};

				scope.saveXeroSettings = () => {
					if (isXeroDataValid()) {
						scope.button_disabled = true;
						const data = gatherData2Save();
						const {
							currentPaymentAccountId,
							currentRevenueAccountId
						} = scope.accounts;
						const isSettingsToUpdate =
							currentPaymentAccountId || currentRevenueAccountId;

						$http({
							method: isSettingsToUpdate ? 'PUT' : 'POST',
							url: '/api/user/xero/settings',
							data
						})
							.then(() => successSetAccount())
							.catch(messageService.showDefaultErrorMessage)
							.finally(() => scope.changePathAfterIntegration());
					}
				};

				function isXeroDataValid() {
					if (!scope.chosenRevenueAccount) {
						messageService.showToaster('e_18', 'xero');
						return false;
					}

					if (scope.enablePaymentsCopying && !scope.chosenPaymentAccount) {
						messageService.showToaster('e_19', 'xero');
						return false;
					}
					return true;
				}
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Integrations/integrateWithXeroModal.js